import { TEXT } from 'locales/translations';
import { Headline, Row, Col, Link, Paragraph, BackgroundImage } from 'Common';

import { collaborationOffer } from 'images/landingpages/b2b_landingpage';
import Style from './CollaborationOffer.style';

export default () => {
  return (
    <Style>
      <Row>
        <Col xs="12" md={{ size: 10, offset: 1 }} lg={{ size: 6, offset: 0 }} className="text-center text-lg-start">
          <Headline level={1}>{TEXT.healthAdvisor.collaborationOffer.headline}</Headline>
          <Paragraph className="intro mt-4">{TEXT.healthAdvisor.collaborationOffer.body}</Paragraph>
          <Link to="#inquiryForm" button className="btn-inverted button" aria-label="Zum Kontaktformular scrollen.">
            {TEXT.healthAdvisor.collaborationOffer.button}
          </Link>
        </Col>
        <Col xs={{ size: 12, offset: 0 }} md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 0 }}>
          <BackgroundImage image={collaborationOffer} className="header-image" />
        </Col>
      </Row>
    </Style>
  );
};
